import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import styles from "./index.css";
import {
  getPageSpecificAnalyticsData,
  getListType,
} from "../../analytics/pageLoad";
import addUpSellCarousel from "./addUpSellCarousel";
import addAdvert from "./addAdvert";
import getFocusTileIndex from "./getFocusTileIndex";
import mapProductsToProductTiles from "./mapProductsToProductTiles";
import addCategoryPreviews from "./addCategoryPreviews";
import addLoyaltyMembersDayBanner from "./addLoyaltyMembersDayBanner";
import addLoyaltyEarlyAccessSaleBanner from "./addLoyaltyEarlyAccessSaleBanner";
import getAdditionalItemPositionFinder from "./getAdditionalItemPositionFinder";
import useProductListScrollAnalytics from "./hooks/useProductListScrollAnalytics";
import { getCurrencyCode } from "../../state/modules/config/selectors";
import { getRequestId } from "../../state/modules/search/domains/diagnostics/selectors";

const ListingPage = ({
  isInitialPage,
  page: { products, pageNumber },
  focusFirstTile,
  focusLastTile,
  advert,
  upSellCarousel,
  treatments,
  viewportCategory,
  ...rest
}) => {
  const positionFinder = useSelector(getAdditionalItemPositionFinder);
  const { pageType, isBrand } = useSelector(getPageSpecificAnalyticsData);
  const localCurrencyCode = useSelector(getCurrencyCode);
  const requestId = useSelector(getRequestId);
  const itemListName = getListType({ pageType, isBrand });
  const focusTileIndex = getFocusTileIndex({
    focusFirstTile,
    focusLastTile,
    products,
  });

  const initialProductsTilesArray = mapProductsToProductTiles({
    products,
    focusTileIndex,
    isInitialPage,
    pageNumber,
    ...rest,
  });

  let items = [...initialProductsTilesArray];

  const getAdditionalItemPosition = positionFinder({
    products,
    productTiles: initialProductsTilesArray,
    viewportCategory,
  });

  items = addAdvert({
    advert,
    items,
    positionFinder: getAdditionalItemPosition,
  });

  items = addUpSellCarousel({
    upSellCarousel,
    items,
    positionFinder: getAdditionalItemPosition,
  });

  if (pageNumber === 1) {
    items = addCategoryPreviews({
      treatments,
      positionFinder: getAdditionalItemPosition,
      items,
      viewportCategory,
    });
  }

  if (pageNumber === 1) {
    items = addLoyaltyMembersDayBanner({
      viewportCategory,
      positionFinder: getAdditionalItemPosition,
      items,
    });
  }

  if (pageNumber === 1) {
    items = addLoyaltyEarlyAccessSaleBanner({
      viewportCategory,
      positionFinder: getAdditionalItemPosition,
      items,
    });
  }

  const { listRef } = useProductListScrollAnalytics({
    viewportCategory,
    products,
    pageNumber,
    itemListName,
    localCurrencyCode,
    requestId,
  });

  return (
    <ul
      ref={listRef}
      className={styles.listingPage}
      data-auto-id={pageNumber}
      data-testid={`listing-results-${pageNumber}`}
    >
      {items}
    </ul>
  );
};

ListingPage.propTypes = {
  isInitialPage: PropTypes.bool.isRequired,
  page: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    pageNumber: PropTypes.number,
  }),
  focusFirstTile: PropTypes.bool.isRequired,
  focusLastTile: PropTypes.bool.isRequired,
  advert: PropTypes.func,
  upSellCarousel: PropTypes.func,
  treatments: PropTypes.object,
  viewportCategory: PropTypes.string,
};

export default ListingPage;
